var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "canvas_layout" },
    [
      _c("canvas", { attrs: { id: "canvas" } }),
      _vm._v(" "),
      _c("el-button", { on: { click: _vm.clearRect } }, [_vm._v("クリア")]),
      _vm._v(" "),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.updateImageData } },
        [_vm._v("保存する")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }